export const formatPercentage = (percentage: number, precision = 1): string => {
  if (!isFinite(percentage)) {
    return "" // Return an empty string if the percentage is Infinity or NaN
  }
  return `${(100 * percentage).toFixed(precision)}%`
}
